import React from 'react'

import { Button } from 'ui/components/Button'
import {
    Modal,
    ModalCloseTrigger,
    ModalContent,
    ModalContentInner,
    ModalFooter,
    ModalFooterButtonGroup,
    ModalHeader,
    ModalTrigger,
} from 'ui/components/Modal'
import { Textarea } from 'ui/components/Textarea'
import { useToast } from 'ui/components/Toast'

type RerunMessagesModalProps = {
    rerunFn: (messageIds: string[]) => Promise<void>
}

export function RerunMessagesModal({ rerunFn }: RerunMessagesModalProps) {
    const [messageIds, setMessageIds] = React.useState('')
    const [open, setOpen] = React.useState(false)
    const toast = useToast()

    const handleRunMessages = React.useCallback(async () => {
        try {
            await rerunFn(messageIds.split('\n'))
            setOpen(false)
            toast({
                title: 'Messages re-run successfully',
                type: 'success',
            })
        } catch (error) {
            console.error(error)
            toast({
                title: 'Error re-running messages',
                type: 'error',
            })
        }
    }, [messageIds, rerunFn, toast])

    return (
        <Modal open={open} onOpenChange={setOpen}>
            <ModalTrigger asChild>
                <Button variant="secondary">Re-run Messages</Button>
            </ModalTrigger>
            <ModalContent>
                <ModalHeader
                    title="Re-run Messages"
                    subtitle="Paste message IDs to re-run (one per line)"
                    showCloseButton={true}
                />
                <ModalContentInner>
                    <Textarea
                        placeholder="Enter message IDs here..."
                        rows={10}
                        value={messageIds}
                        onChange={(e) => setMessageIds(e.target.value)}
                    />
                </ModalContentInner>
                <ModalFooter>
                    <ModalFooterButtonGroup>
                        <Button size="s" variant="primary" onClick={handleRunMessages}>
                            Run Messages
                        </Button>
                        <ModalCloseTrigger asChild>
                            <Button variant="secondary" size="s">
                                Cancel
                            </Button>
                        </ModalCloseTrigger>
                    </ModalFooterButtonGroup>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
